import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { PollApiCalls } from "../../apis/PollApiCalls";
import { UserApiCalls } from "../../apis/UserApiCalls";
import { Spin } from "../standardization/YuJaLoading";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import { useLoading } from "../../utils/LoadingContext";
import { useTranslation } from "react-i18next";
import {
    BUTTON,
    DEFAULT_ROWS_PER_PAGE,
    QUESTION_TYPES,
    TEXTBOX,
    USER_SETTINGS,
    ACTIVITY_EDITOR_VIEW
} from "../../utils/constants";
import {notifyError, notifySuccess, stripHTMLTags} from "../../utils/helpers";
import {
    getBlankRestriction,
    trimLineBreakerInQuestion
} from "../../utils/questionUtils";
import YuJaButton from "../standardization/YuJaButton";
import { YuJaCheckbox } from "../standardization/YuJaCheckbox";
import QuestionBankSearch from "./QuestionBankSearch";
import QuestionProfileTable from "./QuestionProfileTable";
import styles from "./QuestionProfiles.module.css";
import {useImageLoaderManager} from "../../hooks/useImageLoaderManager";
import {convertToPlainString, hasLatex, LatexInline} from "../Tiptap/latexParser";

export default function QuestionProfileModal({setModalShow, show, setEditorView, setQuestions, questions, setCurrQueDisplay, getPollKey, userSettings}) {
    const { t } = useTranslation();

    const {getUuid, setQuestionsLoading, resetImages, setImages} = useImageLoaderManager(questions, setQuestions);
    const [questionProfileData, setQuestionProfileData] = useState([]);
    const [dataReady, setDataReady] = useState(false);
    const { importBankImage } = PollApiCalls();
    const { listQuestionProfiles } = UserApiCalls();
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [selectedProfileId, setSelectedProfileId] = useState(null);
    const [selectedProfileName, setSelectedProfileName] = useState(null);
    const [checkedValues, setCheckedValues] = useState(new Map());
    // const [setRecentQuestions, getRecentQuestions] = useLocalStorageNew("recentQuestions", []);
    const [selectedQuestionProfile, setSelectedQuestionProfile] = useState(""); 
    const [isImporting, setIsImporting] = useState(true);
    const history = useHistory();
    const { loading, setLoading } = useLoading();
    // const [collapsed, setCollapsed] = useState(new Map()); 
    // const [data, setData] = useState([]);
    const [questionTitleLimit, setQuestionTitleLimit] = useState(60);

    const [filter, setFilter] = useState({});

    const handleClose = () =>{
        handleSearch({ keyword: ""});
        setIsImporting(false);
        setCheckedValues(new Map());
        setModalShow(false); 
    };

    const buttonStyle = {width: 90, height: 35, display: "flex", justifyContent: "center", alignItems: "center", whiteSpace: "nowrap"};

    // const isValidQue = (pollType, questionType) => {
    //     if (!pollType || !questionType) {
    //         return false;
    //     }

    //     const isInvalid = (pollType === GRADED_POLL && (questionType === QUESTION_TYPES.WC.name || questionType === QUESTION_TYPES.RK.name))
    //         || (pollType === SURVEY && questionType === QUESTION_TYPES.MH.name);
    //     return !isInvalid
    // }

    const selectAllProfile = () => {
        const updatedMap = new Map(checkedValues);
        if (selectedProfile) {
            if(!updatedMap.get(selectedProfileId)) {
                updatedMap.set(selectedProfileId, []); 
            }
          Array.from(selectedProfile.values()).map((value, index) => {
            if (!updatedMap.get(selectedProfileId).includes(index)) {
                //(pollType === SURVEY && value.questionType !== QUESTION_TYPES.MH.name) || (pollType === GRADED_POLL && value.questionType !== QUESTION_TYPES.WC.name)
                // if (isValidQue(pollType, value.questionType)) {
                updatedMap.get(selectedProfileId).push(index);
                // }
            }
          });
        }
        setCheckedValues(updatedMap);
    };

    const clearAllProfile = () => {
        const updatedMap = new Map(checkedValues);
        if (selectedProfile) {
            if(!updatedMap.get(selectedProfileId)) {
                updatedMap.set(selectedProfileId, []); 
            }
          Array.from(selectedProfile.values()).map((value, index) => {
            if (updatedMap.get(selectedProfileId).includes(index)) {
                const pos = updatedMap.get(selectedProfileId).indexOf(index);
                updatedMap.get(selectedProfileId).splice(pos, 1);
            }
          });
        }
        setCheckedValues(updatedMap);
    };

    const checkHasSelected = () => {
        let checkedLength = 0;

        checkedValues.forEach((value, key, map) => {
            checkedLength += value.length;
        })
        return !checkedLength

    }

    const handleSubmit = async () => {
        try {
            setLoading(true);
            let questionsCopy = JSON.parse(JSON.stringify(questions));
            const size = questionsCopy.length;
            const lastQ = size ? questionsCopy[size - 1] : {};
            if (!lastQ.questionType && !!checkedValues.size) {
                questionsCopy.pop();
            }


            let idx = 0;
            let bankQuestions = [];
            let selectedQuestions = [];

            let questionBankMapping = {};
            let totalResourceMapping = {};

            for (let [key, list] of checkedValues) {
                const questionList = questionProfileData.get(key).questions;

                const questionsGroup = [];
                for (const [, i] of list.entries()) {
                    const modifiedQuestion = JSON.parse(JSON.stringify(questionList[i]));
                    trimLineBreakerInQuestion(modifiedQuestion);

                    if (!modifiedQuestion.hasOwnProperty("queTitle")) {
                        modifiedQuestion.queTitle = "";
                    }
                    if (modifiedQuestion.questionType === QUESTION_TYPES.MH.name && !modifiedQuestion.correctAnswers) {
                        modifiedQuestion.correctAnswers = modifiedQuestion.optionsMap;
                    }

                    if (modifiedQuestion.questionType === QUESTION_TYPES.FITB.name) {
                        modifiedQuestion.hasBlankRestriction = getBlankRestriction([modifiedQuestion]);
                    }

                    modifiedQuestion.getReadyTimeLimit = userSettings[USER_SETTINGS.QUESTION_COUNTDOWN];
                    modifiedQuestion.entries = userSettings[USER_SETTINGS.QUESTION_ENTRIES];
                    modifiedQuestion.serialNo = questionsCopy.length + idx + 1;
                    modifiedQuestion.classResultDuration = userSettings[USER_SETTINGS.QUESTION_CLASS_RESULT_DURATION];
                    bankQuestions.push(modifiedQuestion);
                    questionsGroup.push(modifiedQuestion);
                    selectedQuestions.push({...questionList[i]});
                    idx++;
                }


                const resourceMapping = setQuestionsLoading(questionsGroup, key);

                totalResourceMapping = {...totalResourceMapping, ...resourceMapping};
                for (const image of Object.keys(resourceMapping)) {
                    questionBankMapping[image] = key;
                }
            }



            if (!bankQuestions.length) {
                notifyError(t("questionBank.importSelectError"));
                return;
            }


            let pollKeyTemp = getPollKey();
            // if (!pollKeyTemp) {
            //     pollKeyTemp = getUuid();
            //     changePollKey(pollKeyTemp);
            // }

            if (!!Object.entries(totalResourceMapping).length) {
                importBankImage(pollKeyTemp, totalResourceMapping)
                    .then(returnedMapping => {
                        //error
                        if (!returnedMapping) {
                            resetImages(Object.values(totalResourceMapping));
                            return;
                        }

                        //set imageURL
                        setImages(returnedMapping);
                    });
            }


            questionsCopy = questionsCopy.concat(bankQuestions);
            setQuestions(questionsCopy);
            setCurrQueDisplay(questionsCopy.length);
            setCheckedValues(new Map());
            handleSearch({ keyword: "" });
            notifySuccess(t("questionBank.importSuccess"));
            setModalShow(false);
            setEditorView(ACTIVITY_EDITOR_VIEW.QUESTION_EDITING);
        } catch (error) {
            console.log(error)
            notifyError(t("questionBank.importError"));
        } finally {
            setIsImporting(false);
            setLoading(false);
        }
    }

    const handleCheckboxChange = (index) => {
        const updatedMap = new Map(checkedValues);

        if(!updatedMap.get(selectedProfileId)) {
            updatedMap.set(selectedProfileId, []); 
        }
      
        if(updatedMap.get(selectedProfileId).includes(index)) {
            const pos = updatedMap.get(selectedProfileId).indexOf(index);
            updatedMap.get(selectedProfileId).splice(pos, 1);
        }
        else {
            updatedMap.get(selectedProfileId).push(index);
          }
        setCheckedValues(updatedMap);
    }

    const handleKeyClick = (value, index) => {
        const keyArray = Array.from(questionProfileData.keys());
        setSelectedProfile(value.questions);
        setSelectedProfileId(keyArray[index]); 
        setSelectedProfileName(value.ProfileTitle);
        setIsImporting(true);
    };

    const getQuestionProfiles = async () => {
        setDataReady(false); 
        const res = await listQuestionProfiles();
        const sortedArray = Object.entries(res)
            .sort((a, b) => new Date(Date.parse(b[1].creationTime)) - new Date(Date.parse(a[1].creationTime)));
        const sortedMap = new Map(sortedArray);  
        setQuestionProfileData(sortedMap); 
        setDataReady(true);
    };

    useEffect(() => {
        if(show === true) {
            getQuestionProfiles(); 
            setIsImporting(false);
            setCheckedValues(new Map());
            setSelectedProfile(null); 
            setSelectedProfileId(null);
            setSelectedProfileName(null);
            setSelectedQuestionProfile("");
            // setCollapsed(false);
        }
    }, [show]);

    // useEffect(() => {
    //     const collapsedMap = new Map(); 
    //     Array.from(questionProfileData.keys()).map((value, index) => {
    //         collapsedMap.set(value, false)
    //       });
    //     setCollapsed(collapsedMap); 
    // }, [questionProfileData])

    useEffect(() => {
        if(selectedProfileId && !checkedValues.has(selectedProfileId)) {
            setCheckedValues((prevCheckedQuestions) => {
                const updatedMap = new Map(prevCheckedQuestions);
                updatedMap.set(selectedProfileId, []); 
                return updatedMap; 
            }); 
        }
    }, [selectedProfileId])

    const columns = [
        { Header: t("table.questionBankNameHeader"), accessor: 'title', width: 200 },
        { Header: t("table.questionsHeader"), accessor: 'questions', width: 100 },
        // { Header: t("common.actionsLabel"), accessor: '', width: 100, id: 'action' },
      ];

    const onEdit = (questionProfileId) => {
        setModalShow(false);
        history.push({ pathname: "/questions/edit/" + questionProfileId });
    }

    useEffect(() => {
        const updateConstantValue = () => {
          const windowWidth = window.innerWidth;
          if (windowWidth <= 395) {
            setQuestionTitleLimit(20);
          }
          else if (windowWidth <= 495 ) {
            setQuestionTitleLimit(30);
          }
          else if (windowWidth <= 1500) {
            setQuestionTitleLimit(40);
          } else if (windowWidth <= 1800) {
            setQuestionTitleLimit(50);
          } else {
            setQuestionTitleLimit(60);
          }
        };
    
        // Call the function once to set the initial value
        updateConstantValue();
    
        // Add an event listener to handle window resize
        window.addEventListener('resize', updateConstantValue);
    
        // Clean up the event listener when the component is unmounted
        return () => {
          window.removeEventListener('resize', updateConstantValue);
        };
      }, []);

    const handleSearch = useCallback(({ ...filterObj }) => {
        setFilter(filterObj);
      }, []);
    
    return (
        <Modal
            id="form-modal"
            show={show}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={true}
            dialogClassName= {"qp-modal"}
        >

            <ModalClose tabIndex={0} aria-label={t("common.close")} role={BUTTON} onClick={handleClose} className="modal-close" style={{width: "24px", height: "24px"}}/>
            <Modal.Header
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    {t("questionBank.title")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!isImporting ?
                    <>
                        <div>
                            <div style={{
                                fontSize: 14,
                                lineHeight: 1.6,
                                marginTop: "5px",
                                
                                color: "#696969"
                            }}> {t("questionBank.importChooseMessage")} </div>
                            {/* <div className="questionProfile-layout">
            {Array.from(questionProfileData.values()).map((value, index) => (
                // <div style = {{overflowWrap: "break-word"}} className={selectedProfile != value.questions ? "QuestionProfile-value": "QuestionProfile-value-selected"} onClick={() => handleKeyClick(value, index)}>{value.ProfileTitle}</div>
                <>
                    <div className="questionProfile-cards" onClick={() => {setIsImporting(true); handleKeyClick(value, index);}}>
                        <div style={{flex: '80%', overflowWrap: "break-word", width: "80%"}}>{value.ProfileTitle.length > 30 ? `${value.ProfileTitle.slice(0, 30)}...` :value.ProfileTitle} </div>  
                        <div style={{flex: '20%', display: "flex", flexDirection: "row-reverse", height: "100%", alignSelf: "flex-start", zIndex: "100"}}> <div style={{display: "flex", flexDirection: "column"}}> 
                        {!collapsed || !collapsed.get(Array.from(questionProfileData.keys())[index]) ? <FcMenu
                                onClick={(e) => {
                                    const updatedMap = new Map(collapsed);
                                    const collapse = collapsed.get(Array.from(questionProfileData.keys())[index])
                                    updatedMap.set(Array.from(questionProfileData.keys())[index], !collapse); 
                                    setCollapsed(updatedMap);
                                    e.stopPropagation();
                                }}
                                size={24}
                            /> :
                        
                        <>
                        <img
                            src={EditIcon}
                            alt="edit icon"
                            style={{margin: "0px", padding: "0px", cursor: "pointer",width: "24px", height: "24px",  zIndex: "100"}}
                            title={"Edit Question"}
                            onClick={(e) => { onEdit(Array.from(questionProfileData.keys())[index]); e.stopPropagation();}}
                        />
                        <img
                            src={DeleteIcon}
                            alt="delete icon"
                            style={{ marginRight: "2px", padding: "0px", cursor: "pointer", width: "24px", height: "24px",  zIndex: "100"}}
                            title={"Delete Question"}
                            onClick={(e) => {onDelete(Array.from(questionProfileData.keys())[index]); e.stopPropagation();}}
                        /> </> } 
                        </div></div> 
                    </div>       
                </>
                ))}
            </div>  */}
                            <QuestionBankSearch buttonStyle={buttonStyle} handleSubmit={handleSearch} disabled={!dataReady}/>
                            {dataReady
                                ?
                                <QuestionProfileTable columns={columns} data={Array.from(questionProfileData.values())}
                                                      getQuestionProfiles={getQuestionProfiles}
                                                      keys={Array.from(questionProfileData.keys())}
                                                      selectedQuestionProfile={selectedQuestionProfile}
                                                      setSelectedQuestionProfile={setSelectedQuestionProfile}
                                                      setIsImporting={setIsImporting} setModalShow={setModalShow}
                                                      handleKeyClick={handleKeyClick} globalFilterObj={filter}
                                                      buttonStyle={buttonStyle}
                                />
                                :
                                <div className={styles.skeletonTableContainer}>
                                    <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                        <div className={styles.skeletonHeaderContainer}>
                                            <div className={styles.skeletonHeaderCell}>{t("table.questionBankNameHeader")}</div>
                                            <div className={styles.skeletonActionHeaderCell}>{t("table.questionsHeader")}</div>
                                            <div className={styles.skeletonActionHeaderCell}>{t("common.actionsLabel")}</div>
                                        </div>
                                        <div className={styles.skeletonBodyContainer}>
                                            {Array.apply(null, Array(DEFAULT_ROWS_PER_PAGE)).map((_, idx) => {
                                                return (<div key={idx} className={styles.skeletonBodyRow}>
                                                    <Skeleton height={20}  borderRadius={10} inline={true}
                                                              width={`${6 + Math.random() * 3}vw`}
                                                              className={styles.skeletonBodyCell}
                                                              containerClassName={styles.skeletonBodyCellWrapper}/>
                                                    <Skeleton height={20}  borderRadius={10} inline={true} width={`${2 + Math.random()}vw`}
                                                              className={styles.skeletonActionBodyCell}
                                                              containerClassName={styles.skeletonBodyCellWrapper}/>
                                                    <Skeleton height={20}  borderRadius={10} inline={true} width="2vw"
                                                              className={styles.skeletonActionBodyCell}
                                                              containerClassName={styles.skeletonBodyCellWrapper}/>
                                                </div>)
                                            })}
                                        </div>
                                    </SkeletonTheme>
                                </div>
                            }
                        </div>
                    </>
                    : <div style={{padding: "10px 0px 0px 10px"}}>
                        <div style={{display: "flex", justifyContent: "space-between"}}>
                            <div>
                                <div style={{
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    color: "#000000"
                                }} title={selectedProfileName?.length > 30 ? selectedProfileName : ""}>
                                    {selectedProfileName?.length > 30 ? `${selectedProfileName.slice(0, 30)}...` : selectedProfileName}
                                </div>
                                <div style={{
                                    fontSize: 14,
                                    lineHeight: 1.6,
                                    marginTop: "5px",
                                    
                                    color: "#696969"
                                }}> {t("questionBank.importMessage")} </div>
                            </div>
                            {/* <YuJaButton style={{fontSize: 14, padding: 5}} onClick={(e) => {
                                onEdit(selectedProfileId);
                                e.stopPropagation();
                            }}>
                                <EditIcon style={{width: 20, height: 20}}/>{t("questionBank.editBankButton")}
                            </YuJaButton> */}
                        </div>
                        {/* <div>
            {Array.from(questionProfileData.values()).map((value, index) => (
                // <div style = {{overflowWrap: "break-word"}} className={selectedProfile != value.questions ? "QuestionProfile-value": "QuestionProfile-value-selected"} onClick={() => handleKeyClick(value, index)}>{value.ProfileTitle}</div>
                <>
                    <div className={selectedProfile != value.questions ? "questionProfile-cards": "questionProfile-cards-activated"} onClick={() => handleKeyClick(value, index)}>
                        <div style={{flex: '100%', overflowWrap: "break-word", width: "80%"}}>{value.ProfileTitle.length > 30 ? `${value.ProfileTitle.slice(0, 30)}...` :value.ProfileTitle} </div>  
                    </div>       
                </>
                ))}
            </div> */}
                        <div style={{
                            flex: '7 1 70%',
                            maxHeight: "70vh",
                            minHeight: "20vh",
                            marginTop: "20px",
                            overflowY: "auto"
                        }}>
                            <div style={{display: "flex", gap: "20px"}}>
                                <YuJaButton style={buttonStyle} onClick={() => selectAllProfile()}>
                                    {t("questionBank.selectAllText")}
                                </YuJaButton>
                                <YuJaButton onClick={() => clearAllProfile()}  style={buttonStyle}>
                                    {t("questionBank.clearAllText")}
                                </YuJaButton>
                            </div>
                            <div style={{marginTop: "10px", borderBottom: "0.73px solid #8A8A8A"}}>
                                {selectedProfile &&
                                    <>
                                        {Array.from(selectedProfile.values()).map((value, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    display: "flex",
                                                    gap: "10px",
                                                    alignItems: "center",
                                                    width: "100%",
                                                    border: "0.73px solid #8A8A8A",
                                                    borderBottom: "0px",
                                                    height: "33px",
                                                    padding: "0 10px",
                                                }}
                                            >
                                                <YuJaCheckbox
                                                    id={selectedProfileId + index}
                                                    ariaLabel={t("questionBank.checkboxAriaPrefix") + value.queTitle + " " + (checkedValues.has(selectedProfileId) && checkedValues.get(selectedProfileId).includes(index) ? "checked" : "unchecked")}
                                                    checked={checkedValues.has(selectedProfileId) && checkedValues.get(selectedProfileId).includes(index)}
                                                    onChange={() => {
                                                        handleCheckboxChange(index)
                                                    }}
                                                    // disabled={!isValidQue(pollType, value.questionType)}
                                                />
                                                <div
                                                    style={{
                                                        flex: 1,
                                                        minWidth: 0,
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: hasLatex(value.queTitle) ? undefined : "ellipsis"
                                                    }}
                                                    title={value.queTitle ? stripHTMLTags(convertToPlainString(value.queTitle)) : ""}
                                                >
                                                    {(!value.queTitle || value.queTitle === "")
                                                        ? t("questionBuilder.untitledQuestion")
                                                        : <LatexInline>{value.queTitle}</LatexInline>
                                                    }
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                }
                            </div>
                            <div style={{display: "flex"}}>
                            </div>
                        </div>
                    </div>
                }
            </Modal.Body>
            <Modal.Footer>
                {!isImporting? 
                    <YuJaButton style={buttonStyle} aria-label={t("questionBank.closeModalAria")} onClick={handleClose} type={"secondary"}>{t("common.cancel")}</YuJaButton>
                    :
                    <>
                        <YuJaButton style={buttonStyle} type={"secondary"} onClick={() => {setIsImporting(false)}}>
                         {t("common.goBack")}
                        </YuJaButton>
                        <YuJaButton style={buttonStyle} onClick={handleSubmit} disabled={loading || checkHasSelected()} >
                            { !loading ? t("common.import") : <Spin size="small" wrapperClassName="globalSpin" spinning={loading}/>}
                        </YuJaButton>
                    </>
                }
            </Modal.Footer>

        </Modal>
    );
}